import { useEffect } from 'react';
import { syncService } from '../services/syncService';
import { useSyncStore } from '../stores/syncStore';

const POLL_INTERVAL_MS = 5_000;

/**
 * Keeps a real-time sync's relance counts current after the sync itself has ended. The relances keep generating
 * in the background, but the progress stream that carried their counts closed with the sync, so while the last
 * snapshot says `filling` this polls the status instead. Mount this ONCE app-wide (RootLayout).
 *
 * Stops on its own once a snapshot reports the fill done, when a new sync takes the store over (`syncing`), and
 * on a company switch (`resetSync` clears the progress).
 */
export function useRelanceFillTracker(): void {
    const filling = useSyncStore(s => !s.syncing && s.progress?.filling === true);
    const setProgress = useSyncStore(s => s.setProgress);

    useEffect(() => {
        if (!filling) return;

        // A poll answered after a company switch or a new sync must not overwrite the store they now own.
        let cancelled = false;
        const id = setInterval(() => {
            void syncService.getStatus()
                .then(status => { if (!cancelled) setProgress(status); })
                .catch(() => undefined);
        }, POLL_INTERVAL_MS);
        return () => { cancelled = true; clearInterval(id); };
    }, [filling, setProgress]);
}
